// deno-fmt-ignore-file
export function FromLiteral(context, type) {
    return type.const;
}
